import { render, staticRenderFns } from "./CreateCarparkMapping.vue?vue&type=template&id=c5f37c78&"
import script from "./CreateCarparkMapping.vue?vue&type=script&lang=js&"
export * from "./CreateCarparkMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports